import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { ServiceCard } from "@/components/cards/ServiceCard";
import { AppointmentCTA } from "@/components/sections/AppointmentCTA";
import { Skeleton } from "@/components/ui/skeleton";

export default function Services() {
  const [services, setServices] = useState(null);
  const [filter, setFilter] = useState("All");

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([])); }, []);

  const categories = services ? ["All", ...Array.from(new Set(services.map((s) => s.category)))] : ["All"];
  const filtered = services ? (filter === "All" ? services : services.filter((s) => s.category === filter)) : [];

  return (
    <>
      <Seo title="Dental Services" description="Comprehensive, precision-led dental services at CDT Greater Noida." path="/services" />
      <PageHeader eyebrow="Our Services" title="Comprehensive care, planned around you" subtitle="Explore our full range of treatments. Every plan begins with a careful diagnosis and clear, honest options." />

      <section className="py-8 lg:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10" data-testid="services-filter">
            {categories.map((c) => (
              <button key={c} onClick={() => setFilter(c)} data-testid={`services-filter-${c}`} className={`px-4 py-2 rounded-full text-sm border transition-colors ${filter === c ? "bg-[var(--cdt-primary)] text-white border-[var(--cdt-primary)]" : "bg-white text-[var(--cdt-text)] border-[color:var(--cdt-border)] hover:bg-[var(--cdt-surface-2)]"}`}>{c}</button>
            ))}
          </div>
          {services === null ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-52 rounded-[var(--cdt-radius-md)]" />)}</div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {filtered.map((s, i) => <ServiceCard key={s.slug} service={s} index={i} />)}
            </div>
          )}
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
